/* eslint-disable */
// Generated from the Syllarys EMS v1 OpenAPI contract. Do not edit by hand.
import { matchesModel } from "../validation.ts";
import { modelSchemas } from "./schemas.ts";
import { referenceCollections, collectionModels } from "./collections.ts";
import type {
  BrandStatistics,
  EnergyReport,
  ExplorerInput,
  ExplorerSource,
  ExplorerResult,
  ScopeAnalysisInput,
  ScopeAnalysisResult,
  InvoiceImportInput,
  InvoiceImportPreview,
  InvoiceImportResult,
  EnergyReportInput,
  EnergyReportPolicy,
  EnergyReportPreview,
  EnergyReportSnapshot,
  EnergyReportSchedule,
  DashboardComposition,
  DashboardResult,
  AcceptedResult,
  AccessGrant,
  AccessRevocationImpact,
  AnalysisAvailability,
  AnalysisRequest,
  AnalysisResponse,
  AccountActivityPage,
  AuditEvent,
  Brand,
  BrandSwitchResult,
  Company,
  Connector,
  ConnectorAccessRightRecord,
  AtrdSettings,
  AtrdStatus,
  ConnectorAccessRights,
  ConnectorEnedisFailedFile,
  ConnectorEnedisFileDiscardInput,
  ConnectorEnedisOrderEntry,
  ConnectorExclusion,
  ConnectorExclusionInput,
  ConnectorReferenceEntry,
  ConnectorCoverage,
  ConnectorCompleteness,
  ConnectorTransitEntry,
  CpePerformancePeriod,
  CpePerformancePeriodInput,
  DeliveryPoint,
  DeleteUserInput,
  DeliveryPointTechnical,
  GasInformativeControl,
  DemoDatabase,
  EmailLogDetail,
  EmailLogListResponse,
  EmailLogStatus,
  Equipment,
  GtbAssociationBatchPreview,
  GtbAssociationBatchApplyInput,
  GtbAssociationBatchResult,
  GtbAssociationInput,
  GtbAssociationApplyInput,
  GtbAssociationPreview,
  GtbAttachmentInput,
  GtbInstallation,
  GtbOverview,
  GtbSensorValues,
  InvitationPreview,
  InvoiceReviewInput,
  LegalEntity,
  LoginResult,
  MandateCase,
  MandateDraftInput,
  MandateFormDraft,
  MandatePublicLinkResult,
  Notification,
  NotificationPreference,
  NotificationPreferenceInput,
  MeasurementBatch,
  MeasurementCorrectionInput,
  MeasurementCorrectionResult,
  Membership,
  Meter,
  MeteringPointMeasurements,
  MeteringPointSeries,
  ConnectorDigestSettings,
  ConnectorDigestSettingsInput,
  ModuleRunEntry,
  ModuleRunLog,
  ConnectorHttpPurgeInput,
  ConnectorHttpPurgeReport,
  ConnectorHttpJournal,
  ConnectorHttpFilter,
  ConnectorHttpRunSearch,
  ConnectorHttpResponse,
  ModuleSettingsInput,
  ModuleSyncStatus,
  PointSyncStatus,
  Portfolio,
  PublicMandateForm,
  PublicMandateSubmission,
  Session,
  Site,
  SiteArea,
  SiteDashboard,
  SiteTagAssignment,
  SiteOfficialDegreeDays,
  SiteWeatherCoverage,
  WeatherStationCatalog,
  WeatherObservations,
  SaveMandateFormDraftInput,
  SavedView,
  SavedViewPreferenceInput,
  PortfolioExport,
  PortfolioExportInput,
  SavedViewScreen,
  SaveViewInput,
  SearchPage,
  SupplierInvoice,
  SupplierInvoiceInput,
  SyncRun,
  SyncRunInput,
  TagDefinition,
  TotpConfirmResult,
  TotpEnrollment,
  User,
  UserSessionSummary,
  UserUpdateInput,
  WeatherImportEntry,
  OfficialWeatherArchive,
  WeatherStationIdentifierInput,
  WorkflowItem,
  WorkflowComment,
  WorkflowAssignee,
  WorkflowCommentInput,
  WorkflowCommentEdit,
  WorkflowAttachment,
  AccessInvitationState,
  AccessInvitationAction,
  WorkflowPublicationPreview,
  WorkflowPublication,
  ReferenceImportFile,
  ReferenceImportTable,
  ReferenceBatchInput,
  ReferenceBatchPreview,
  ReferenceBatchJob,
  ReferenceBatchAction,
  WorkflowAttachments,
  WorkflowAttachmentInput,
  AttachmentTicket,
  NotificationStateInput,
  YoutrustProviderStatus,
} from "../index.ts";

export const apiOperations = {
  getConnectorAtrd: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/atrd",
  },
  updateConnectorAtrdSettings: {
    method: "PUT",
    path: "/platform/connectors/{connectorId}/atrd/settings",
  },
  syncConnectorAtrd: {
    method: "POST",
    path: "/platform/connectors/{connectorId}/atrd/sync",
  },
  downloadConnectorAtrd: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/atrd/documents/{documentId}",
  },
  previewInvoiceImport: {
    method: "POST",
    path: "/brands/{brandId}/invoices/import/preview",
  },
  confirmInvoiceImport: {
    method: "POST",
    path: "/brands/{brandId}/invoices/import/confirm",
  },
  calculateScopeAnalysis: {
    method: "POST",
    path: "/brands/{brandId}/scope-analyses",
  },
  explorerSources: {
    method: "POST",
    path: "/brands/{brandId}/data-explorer/sources",
  },
  queryExplorer: {
    method: "POST",
    path: "/brands/{brandId}/data-explorer/query",
  },
  parseReferenceImport: {
    method: "POST",
    path: "/brands/{brandId}/reference-batches/parse",
  },
  previewReferenceBatch: {
    method: "POST",
    path: "/brands/{brandId}/reference-batches/preview",
  },
  listReferenceBatches: {
    method: "GET",
    path: "/brands/{brandId}/reference-batches",
  },
  createReferenceBatch: {
    method: "POST",
    path: "/brands/{brandId}/reference-batches",
  },
  applyReferenceBatch: {
    method: "POST",
    path: "/brands/{brandId}/reference-batches/{jobId}/apply",
  },
  compensateReferenceBatch: {
    method: "POST",
    path: "/brands/{brandId}/reference-batches/{jobId}/compensate",
  },
  cancelReferenceBatch: {
    method: "POST",
    path: "/brands/{brandId}/reference-batches/{jobId}/cancel",
  },
  login: { method: "POST", path: "/auth/login" },
  confirmTotp: { method: "POST", path: "/auth/totp" },
  disableTotp: { method: "DELETE", path: "/auth/totp" },
  logout: { method: "POST", path: "/auth/logout" },
  requestPasswordRecovery: { method: "POST", path: "/auth/password-recovery" },
  resetPassword: { method: "POST", path: "/auth/password-reset" },
  getInvitation: { method: "GET", path: "/auth/invitations/{token}" },
  acceptInvitation: { method: "POST", path: "/auth/invitations/{token}" },
  startTotpEnrollment: { method: "POST", path: "/auth/totp/enrollment" },
  confirmTotpEnrollment: {
    method: "POST",
    path: "/auth/totp/enrollment/confirm",
  },
  listSessions: { method: "GET", path: "/auth/sessions" },
  revokeSession: { method: "DELETE", path: "/auth/sessions/{sessionId}" },
  getSession: { method: "GET", path: "/session" },
  switchBrand: { method: "POST", path: "/session/active-brand" },
  listPublicBrands: { method: "GET", path: "/public/brands" },
  listBrands: { method: "GET", path: "/platform/brands" },
  createBrand: { method: "POST", path: "/platform/brands" },
  listBrandStatistics: { method: "GET", path: "/platform/brands/statistics" },
  updateBrand: { method: "PUT", path: "/platform/brands/{brandId}" },
  getConnectorDigestSettings: {
    method: "GET",
    path: "/platform/connectors/digest-settings",
  },
  updateConnectorDigestSettings: {
    method: "PUT",
    path: "/platform/connectors/digest-settings",
  },
  listConnectors: { method: "GET", path: "/platform/connectors" },
  upsertConnector: {
    method: "PUT",
    path: "/platform/connectors/{connectorId}",
  },
  runConnectorSync: {
    method: "POST",
    path: "/platform/connectors/{connectorId}/sync-runs",
  },
  listConnectorTransit: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/transit",
  },
  getConnectorCompleteness: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/references/{reference}/completeness",
  },
  getConnectorCoverage: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/coverage",
  },
  listConnectorReferences: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/references",
  },
  listConnectorEnedisOrders: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/enedis-orders",
  },
  listConnectorEnedisFailedFiles: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/enedis-failed-files",
  },
  setConnectorEnedisFileDiscard: {
    method: "POST",
    path: "/platform/connectors/{connectorId}/enedis-failed-files/discard",
  },
  listConnectorExclusions: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/exclusions",
  },
  setConnectorExclusion: {
    method: "PUT",
    path: "/platform/connectors/{connectorId}/exclusions/{reference}",
  },
  liftConnectorExclusion: {
    method: "DELETE",
    path: "/platform/connectors/{connectorId}/exclusions/{reference}",
  },
  listConnectorAccessRights: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/access-rights",
  },
  listConnectorAccessRightHistory: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/access-rights/history",
  },
  listConnectorWeatherImports: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/weather-imports",
  },
  getConnectorModuleSync: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/module-sync",
  },
  updateConnectorModuleSettings: {
    method: "PUT",
    path: "/platform/connectors/{connectorId}/module-settings",
  },
  listConnectorModuleRuns: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/module-runs",
  },
  getConnectorModuleRunLog: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/module-runs/{runId}/log",
  },
  searchConnectorHttpRuns: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/http-diagnostics/runs",
  },
  listConnectorHttpRequests: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/module-runs/{runId}/requests",
  },
  getConnectorHttpResponse: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/module-runs/{runId}/requests/{requestId}",
  },
  purgeConnectorHttpDiagnostics: {
    method: "POST",
    path: "/platform/connectors/{connectorId}/http-diagnostics/purge",
  },
  listGtbInstallations: { method: "GET", path: "/platform/gtb-installations" },
  previewGtbAssociation: {
    method: "POST",
    path: "/platform/gtb-installations/{installationId}/associations/preview",
  },
  applyGtbAssociation: {
    method: "POST",
    path: "/platform/gtb-installations/{installationId}/associations/apply",
  },
  previewGtbAssociationBatch: {
    method: "POST",
    path: "/platform/gtb-installations/{installationId}/associations/batch-preview",
  },
  applyGtbAssociationBatch: {
    method: "POST",
    path: "/platform/gtb-installations/{installationId}/associations/batch-apply",
  },
  listGtbSensorValues: {
    method: "GET",
    path: "/platform/gtb-sensors/{sensorId}/values",
  },
  attachGtbInstallation: {
    method: "PUT",
    path: "/platform/gtb-installations/{installationId}/attachment",
  },
  detachGtbInstallation: {
    method: "DELETE",
    path: "/platform/gtb-installations/{installationId}/attachment",
  },
  listMeteringPointSeries: {
    method: "GET",
    path: "/platform/metering-points/{reference}/series",
  },
  listMeteringPointMeasurements: {
    method: "GET",
    path: "/platform/metering-points/{reference}/measurements",
  },
  listPlatformAuditEvents: { method: "GET", path: "/platform/audit-events" },
  listPlatformAccountActivity: {
    method: "GET",
    path: "/platform/account-activity",
  },
  listPlatformEmailLogs: { method: "GET", path: "/platform/email-logs" },
  getPlatformEmailLog: {
    method: "GET",
    path: "/platform/email-logs/{emailLogId}",
  },
  listSyncRuns: { method: "GET", path: "/platform/sync-runs" },
  getPortfolio: { method: "GET", path: "/brands/{brandId}/portfolio" },
  searchBrand: { method: "GET", path: "/brands/{brandId}/search" },
  listCompanies: { method: "GET", path: "/brands/{brandId}/companies" },
  createCompany: { method: "POST", path: "/brands/{brandId}/companies" },
  updateCompany: {
    method: "PUT",
    path: "/brands/{brandId}/companies/{companyId}",
  },
  listSites: { method: "GET", path: "/brands/{brandId}/sites" },
  createSite: { method: "POST", path: "/brands/{brandId}/sites" },
  updateSite: { method: "PUT", path: "/brands/{brandId}/sites/{siteId}" },
  listDeliveryPoints: {
    method: "GET",
    path: "/brands/{brandId}/delivery-points",
  },
  createDeliveryPoint: {
    method: "POST",
    path: "/brands/{brandId}/delivery-points",
  },
  updateDeliveryPoint: {
    method: "PUT",
    path: "/brands/{brandId}/delivery-points/{pointId}",
  },
  getDeliveryPointTechnical: {
    method: "GET",
    path: "/brands/{brandId}/delivery-points/{pointId}/technical",
  },
  getDeliveryPointGasControl: {
    method: "GET",
    path: "/brands/{brandId}/delivery-points/{pointId}/gas-control",
  },
  getDeliveryPointConsumptionTotals: {
    method: "GET",
    path: "/brands/{brandId}/delivery-points/{pointId}/consumption-totals",
  },
  listPointSyncs: { method: "GET", path: "/brands/{brandId}/point-syncs" },
  listDeliveryPointAssignments: {
    method: "GET",
    path: "/brands/{brandId}/delivery-points/{pointId}/assignments",
  },
  transferDeliveryPoint: {
    method: "POST",
    path: "/brands/{brandId}/delivery-points/{pointId}/transfer",
  },
  listSiteAreas: { method: "GET", path: "/brands/{brandId}/site-areas" },
  upsertSiteArea: {
    method: "PUT",
    path: "/brands/{brandId}/site-areas/{areaId}",
  },
  deleteSiteArea: {
    method: "DELETE",
    path: "/brands/{brandId}/site-areas/{areaId}",
  },
  listTags: { method: "GET", path: "/brands/{brandId}/tags" },
  upsertTag: { method: "PUT", path: "/brands/{brandId}/tags/{tagId}" },
  deleteTag: { method: "DELETE", path: "/brands/{brandId}/tags/{tagId}" },
  listSiteTags: { method: "GET", path: "/brands/{brandId}/site-tags" },
  assignSiteTag: {
    method: "PUT",
    path: "/brands/{brandId}/sites/{siteId}/tags/{tagId}",
  },
  removeSiteTag: {
    method: "DELETE",
    path: "/brands/{brandId}/sites/{siteId}/tags/{tagId}",
  },
  listMeters: { method: "GET", path: "/brands/{brandId}/meters" },
  upsertMeter: { method: "PUT", path: "/brands/{brandId}/meters/{meterId}" },
  deleteMeter: { method: "DELETE", path: "/brands/{brandId}/meters/{meterId}" },
  listEquipment: { method: "GET", path: "/brands/{brandId}/equipment" },
  upsertEquipment: {
    method: "PUT",
    path: "/brands/{brandId}/equipment/{equipmentId}",
  },
  deleteEquipment: {
    method: "DELETE",
    path: "/brands/{brandId}/equipment/{equipmentId}",
  },
  listUsers: { method: "GET", path: "/brands/{brandId}/users" },
  updateUser: { method: "PUT", path: "/brands/{brandId}/users/{userId}" },
  deleteUser: { method: "DELETE", path: "/brands/{brandId}/users/{userId}" },
  inviteAccessUser: {
    method: "POST",
    path: "/brands/{brandId}/access-invitations",
  },
  assignAccessGrant: {
    method: "POST",
    path: "/brands/{brandId}/access-grants",
  },
  revokeAccessGrant: {
    method: "DELETE",
    path: "/brands/{brandId}/access-grants/{grantId}",
  },
  previewAccessGrantRevocation: {
    method: "GET",
    path: "/brands/{brandId}/access-grants/{grantId}/revocation-impact",
  },
  listMeasurementSeries: {
    method: "GET",
    path: "/brands/{brandId}/measurement-series",
  },
  listMeasurements: { method: "GET", path: "/brands/{brandId}/measurements" },
  correctMeasurement: {
    method: "POST",
    path: "/brands/{brandId}/series/{seriesId}/measurements/{valueId}/corrections",
  },
  getSiteOfficialDegreeDays: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/degree-days",
  },
  getSiteWeatherStations: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/weather-stations",
  },
  getSiteWeatherObservations: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/weather-observations",
  },
  getConnectorWeatherStations: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/weather-stations",
  },
  getConnectorWeatherObservations: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/weather-observations",
  },
  getSiteWeather: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/weather",
  },
  getSiteDashboard: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/dashboard",
  },
  getSiteConsumptionTotals: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/consumption-totals",
  },
  getAnalysisAvailability: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/analysis-availability",
  },
  calculateAnalysis: {
    method: "POST",
    path: "/brands/{brandId}/analyses/{analysisCode}",
  },
  listAnomalies: { method: "GET", path: "/brands/{brandId}/anomalies" },
  listRecommendations: {
    method: "GET",
    path: "/brands/{brandId}/recommendations",
  },
  listWorks: { method: "GET", path: "/brands/{brandId}/works" },
  listReports: { method: "GET", path: "/brands/{brandId}/reports" },
  previewWorkflowPublication: {
    method: "GET",
    path: "/brands/{brandId}/workflow-items/{itemId}/publication-preview",
  },
  listWorkflowPublications: {
    method: "GET",
    path: "/brands/{brandId}/workflow-items/{itemId}/publications",
  },
  getAccessInvitation: {
    method: "GET",
    path: "/brands/{brandId}/users/{userId}/invitation",
  },
  updateAccessInvitation: {
    method: "POST",
    path: "/brands/{brandId}/users/{userId}/invitation",
  },
  listWorkflowAssignees: {
    method: "GET",
    path: "/brands/{brandId}/sites/{siteId}/workflow-assignees",
  },
  upsertWorkflowItem: {
    method: "POST",
    path: "/brands/{brandId}/workflow-items",
  },
  exportPortfolio: {
    method: "POST",
    path: "/brands/{brandId}/portfolio/export",
  },
  listSavedViews: { method: "GET", path: "/brands/{brandId}/saved-views" },
  saveViewPreference: {
    method: "PUT",
    path: "/brands/{brandId}/saved-views/{viewId}/preference",
  },
  saveView: { method: "PUT", path: "/brands/{brandId}/saved-views/{viewId}" },
  deleteSavedView: {
    method: "DELETE",
    path: "/brands/{brandId}/saved-views/{viewId}",
  },
  listWorkflowAttachments: {
    method: "GET",
    path: "/brands/{brandId}/workflow-items/{itemId}/attachments",
  },
  uploadWorkflowAttachment: {
    method: "POST",
    path: "/brands/{brandId}/workflow-items/{itemId}/attachments",
  },
  getWorkflowAttachmentTicket: {
    method: "POST",
    path: "/brands/{brandId}/workflow-items/{itemId}/attachments/{attachmentId}/ticket",
  },
  downloadWorkflowAttachment: {
    method: "GET",
    path: "/brands/{brandId}/workflow-items/{itemId}/attachments/{attachmentId}/download",
  },
  editWorkflowComment: {
    method: "PUT",
    path: "/brands/{brandId}/workflow-items/{itemId}/comments/{commentId}",
  },
  listWorkflowComments: {
    method: "GET",
    path: "/brands/{brandId}/workflow-items/{itemId}/comments",
  },
  addWorkflowComment: {
    method: "POST",
    path: "/brands/{brandId}/workflow-items/{itemId}/comments",
  },
  listNotifications: { method: "GET", path: "/brands/{brandId}/notifications" },
  readNotification: {
    method: "PUT",
    path: "/brands/{brandId}/notifications/{notificationId}/read",
  },
  listNotificationPreferences: {
    method: "GET",
    path: "/brands/{brandId}/notification-preferences",
  },
  saveNotificationPreference: {
    method: "PUT",
    path: "/brands/{brandId}/notification-preferences/{eventType}",
  },
  getMandateFormDraft: {
    method: "GET",
    path: "/brands/{brandId}/mandate-form-draft",
  },
  saveMandateFormDraft: {
    method: "PUT",
    path: "/brands/{brandId}/mandate-form-draft",
  },
  deleteMandateFormDraft: {
    method: "DELETE",
    path: "/brands/{brandId}/mandate-form-draft",
  },
  listMandateCases: { method: "GET", path: "/brands/{brandId}/mandate-cases" },
  createMandateCase: {
    method: "POST",
    path: "/brands/{brandId}/mandate-cases",
  },
  createMandatePublicLink: {
    method: "POST",
    path: "/brands/{brandId}/mandate-public-links",
  },
  previewMandateDocument: {
    method: "GET",
    path: "/brands/{brandId}/mandate-cases/{mandateCaseId}/document",
  },
  downloadMandateDocument: {
    method: "GET",
    path: "/brands/{brandId}/mandate-cases/{mandateCaseId}/documents/{kind}",
  },
  sendMandateForSignature: {
    method: "POST",
    path: "/brands/{brandId}/mandate-cases/{mandateCaseId}/send",
  },
  revokeMandateCase: {
    method: "POST",
    path: "/brands/{brandId}/mandate-cases/{mandateCaseId}/revoke",
  },
  getYoutrustProviderStatus: {
    method: "GET",
    path: "/mandates/provider-status",
  },
  checkYoutrustProviderConnection: {
    method: "POST",
    path: "/mandates/provider-status",
  },
  getPublicMandateForm: {
    method: "GET",
    path: "/public/mandate-links/{token}",
  },
  submitPublicMandateForm: {
    method: "POST",
    path: "/public/mandate-links/{token}",
  },
  receiveYoutrustWebhook: { method: "POST", path: "/webhooks/youtrust" },
  receivePostmarkWebhook: { method: "POST", path: "/webhooks/postmark" },
  listAuditEvents: { method: "GET", path: "/brands/{brandId}/audit-events" },
  listInvoices: { method: "GET", path: "/brands/{brandId}/invoices" },
  createInvoice: { method: "POST", path: "/brands/{brandId}/invoices" },
  reviewInvoice: {
    method: "PUT",
    path: "/brands/{brandId}/invoices/{invoiceId}/review",
  },
  listPerformancePeriods: {
    method: "GET",
    path: "/brands/{brandId}/performance-contracts",
  },
  upsertPerformancePeriod: {
    method: "PUT",
    path: "/brands/{brandId}/performance-contracts/{periodId}",
  },
  deletePerformancePeriod: {
    method: "DELETE",
    path: "/brands/{brandId}/performance-contracts/{periodId}",
  },
  resetDemo: { method: "POST", path: "/demo/reset" },
  listDashboards: { method: "GET", path: "/brands/{brandId}/dashboards" },
  saveDashboard: { method: "PUT", path: "/brands/{brandId}/dashboards" },
  actDashboard: {
    method: "POST",
    path: "/brands/{brandId}/dashboards/{dashboardId}/{action}",
  },
  prepareDashboardResult: {
    method: "POST",
    path: "/brands/{brandId}/dashboard-results",
  },
  getDashboardResult: {
    method: "GET",
    path: "/brands/{brandId}/dashboard-results/{resultId}",
  },
  getEnergyReportPolicy: {
    method: "GET",
    path: "/brands/{brandId}/energy-reports/policy",
  },
  previewEnergyReport: {
    method: "POST",
    path: "/brands/{brandId}/energy-reports/preview",
  },
  listEnergyReports: {
    method: "GET",
    path: "/brands/{brandId}/energy-reports",
  },
  createEnergyReport: {
    method: "POST",
    path: "/brands/{brandId}/energy-reports",
  },
  actEnergyReport: {
    method: "POST",
    path: "/brands/{brandId}/energy-reports/{reportId}/{action}",
  },
  downloadEnergyReportPdf: {
    method: "GET",
    path: "/brands/{brandId}/energy-reports/{reportId}/pdf",
  },
  downloadEnergyReportCsv: {
    method: "GET",
    path: "/brands/{brandId}/energy-reports/{reportId}/csv",
  },
  listReportSchedules: {
    method: "GET",
    path: "/brands/{brandId}/report-schedules",
  },
  saveReportSchedule: {
    method: "PUT",
    path: "/brands/{brandId}/report-schedules",
  },
  getConnectorWeatherClimatology: {
    method: "GET",
    path: "/platform/connectors/{connectorId}/weather-climatology",
  },
  addConnectorWeatherIdentifier: {
    method: "POST",
    path: "/platform/connectors/{connectorId}/weather-identifiers",
  },
} as const;

export class ApiError extends Error {
  public readonly status: number;
  public readonly issues: string[];

  constructor(status: number, message: string, issues: string[] = []) {
    super(message);
    this.status = status;
    this.issues = issues;
    this.name = "ApiError";
  }
}

async function readJson<T>(
  response: Response,
  model?: keyof typeof modelSchemas,
  array = false,
): Promise<T> {
  if (!response.ok) {
    const payload = (await response.json().catch(() => null)) as {
      message?: string;
      issues?: unknown;
    } | null;
    const issues = Array.isArray(payload?.issues)
      ? payload.issues.filter(
          (issue): issue is string => typeof issue === "string",
        )
      : [];
    throw new ApiError(
      response.status,
      payload?.message ?? `Erreur API ${response.status}`,
      issues,
    );
  }
  if (response.status === 204) return undefined as T;
  const value: unknown = await response.json();
  if (
    model &&
    !(array
      ? Array.isArray(value) && value.every((item) => matchesModel(model, item))
      : matchesModel(model, value))
  ) {
    throw new ApiError(
      502,
      "La réponse API ne respecte pas le contrat attendu.",
    );
  }
  return value as T;
}

async function expectNoContent(response: Response): Promise<void> {
  if (!response.ok) await readJson<unknown>(response);
}

type CollectionFilters = {
  siteId?: string;
  companyId?: string;
  status?: string;
  limit?: number;
  offset?: number;
};

function queryString(
  filters: Record<string, string | number | undefined>,
): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== "") query.set(key, String(value));
  }
  const text = query.toString();
  return text ? `?${text}` : "";
}

const JSON_HEADERS = { "Content-Type": "application/json" };

/**
 * Client typé de l'API Syllarys EMS. Le transport est injectable (tests) et
 * le cookie de session est transmis par le navigateur (same-origin).
 */
export class EmsApiClient {
  private readonly baseUrl: string;
  private readonly fetcher: typeof fetch;

  constructor(baseUrl = "/api/v1", fetcher: typeof fetch = fetch) {
    this.baseUrl = baseUrl;
    // Keep the transport as a plain function call. Browser-native fetch rejects
    // an arbitrary class instance as its receiver when invoked as this.fetcher().
    this.fetcher = (input, init) => fetcher(input, init);
  }

  private brandPath(brandId: string, suffix: string): string {
    return `${this.baseUrl}/brands/${encodeURIComponent(brandId)}${suffix}`;
  }

  private json(method: "POST" | "PUT" | "DELETE", body?: unknown): RequestInit {
    return {
      method,
      headers: JSON_HEADERS,
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    };
  }

  // --- Authentification et session ---------------------------------------

  async login(email: string, password: string): Promise<LoginResult> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/login`,
      this.json("POST", { email, password }),
    );
    return readJson<LoginResult>(response, "LoginResult");
  }

  async confirmTotp(challengeId: string, code: string): Promise<Session> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/totp`,
      this.json("POST", { challengeId, code }),
    );
    return readJson<Session>(response, "Session");
  }

  async logout(): Promise<void> {
    const response = await this.fetcher(`${this.baseUrl}/auth/logout`, {
      method: "POST",
      keepalive: true,
    });
    await expectNoContent(response);
  }

  async getSession(): Promise<Session> {
    const response = await this.fetcher(`${this.baseUrl}/session`, {
      cache: "no-store",
    });
    return readJson<Session>(response, "Session");
  }

  async switchBrand(brandId: string): Promise<BrandSwitchResult> {
    const response = await this.fetcher(
      `${this.baseUrl}/session/active-brand`,
      this.json("POST", { brandId }),
    );
    return readJson<BrandSwitchResult>(response, "BrandSwitchResult");
  }

  async requestPasswordRecovery(email: string): Promise<AcceptedResult> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/password-recovery`,
      this.json("POST", { email }),
    );
    return readJson<AcceptedResult>(response, "AcceptedResult");
  }

  async resetPassword(token: string, password: string): Promise<void> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/password-reset`,
      this.json("POST", { token, password }),
    );
    await expectNoContent(response);
  }

  async getInvitation(token: string): Promise<InvitationPreview> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/invitations/${encodeURIComponent(token)}`,
    );
    return readJson<InvitationPreview>(response, "InvitationPreview");
  }

  async acceptInvitation(token: string, password: string): Promise<Session> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/invitations/${encodeURIComponent(token)}`,
      this.json("POST", { password }),
    );
    return readJson<Session>(response, "Session");
  }

  async startTotpEnrollment(): Promise<TotpEnrollment> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/totp/enrollment`,
      { method: "POST" },
    );
    return readJson<TotpEnrollment>(response, "TotpEnrollment");
  }

  async confirmTotpEnrollment(code: string): Promise<TotpConfirmResult> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/totp/enrollment/confirm`,
      this.json("POST", { code }),
    );
    return readJson<TotpConfirmResult>(response, "TotpConfirmResult");
  }

  async disableTotp(password: string): Promise<void> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/totp`,
      this.json("DELETE", { password }),
    );
    await expectNoContent(response);
  }

  async listSessions(): Promise<UserSessionSummary[]> {
    const response = await this.fetcher(`${this.baseUrl}/auth/sessions`);
    return readJson<UserSessionSummary[]>(response, "UserSessionSummary", true);
  }

  async revokeSession(sessionId: string): Promise<void> {
    const response = await this.fetcher(
      `${this.baseUrl}/auth/sessions/${encodeURIComponent(sessionId)}`,
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  // --- Marques -------------------------------------------------------------

  async listPublicBrands(): Promise<Brand[]> {
    const response = await this.fetcher(`${this.baseUrl}/public/brands`);
    return readJson<Brand[]>(response, "Brand", true);
  }

  async listBrands(): Promise<Brand[]> {
    const response = await this.fetcher(`${this.baseUrl}/platform/brands`);
    return readJson<Brand[]>(response, "Brand", true);
  }

  async listBrandStatistics(): Promise<BrandStatistics[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/brands/statistics`,
    );
    return readJson<BrandStatistics[]>(response, "BrandStatistics", true);
  }

  async createBrand(brand: Brand, legalEntity?: LegalEntity): Promise<Brand> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/brands`,
      this.json("POST", { brand, ...(legalEntity ? { legalEntity } : {}) }),
    );
    return readJson<Brand>(response, "Brand");
  }

  async updateBrand(brand: Brand, legalEntity?: LegalEntity): Promise<Brand> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/brands/${encodeURIComponent(brand.id)}`,
      this.json("PUT", { brand, ...(legalEntity ? { legalEntity } : {}) }),
    );
    return readJson<Brand>(response, "Brand");
  }

  // --- Collections --------------------------------------------------------

  async getBrandCollection<K extends keyof typeof referenceCollections>(
    brandId: string,
    collection: K,
    filters: CollectionFilters = {},
  ): Promise<DemoDatabase[(typeof referenceCollections)[K]]> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/${collection}${queryString(filters)}`),
    );
    return readJson<DemoDatabase[(typeof referenceCollections)[K]]>(
      response,
      collectionModels[collection],
      true,
    );
  }

  async getPortfolio(brandId: string): Promise<Portfolio> {
    const response = await this.fetcher(this.brandPath(brandId, "/portfolio"));
    return readJson<Portfolio>(response, "Portfolio");
  }

  async searchBrand(
    brandId: string,
    filters: { q: string; limit?: number; cursor?: string },
    options: { signal?: AbortSignal } = {},
  ): Promise<SearchPage> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/search${queryString(filters)}`),
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<SearchPage>(response, "SearchPage");
  }

  // --- Référentiel --------------------------------------------------------

  async createReferenceEntity<T extends Company | Site | DeliveryPoint>(
    brandId: string,
    kind: "companies" | "sites" | "delivery-points",
    entity: T,
  ): Promise<T> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/${kind}`),
      this.json("POST", entity),
    );
    const model =
      kind === "companies"
        ? "Company"
        : kind === "sites"
          ? "Site"
          : "DeliveryPoint";
    return readJson<T>(response, model);
  }

  async updateCompany(brandId: string, company: Company): Promise<Company> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/companies/${encodeURIComponent(company.id)}`),
      this.json("PUT", company),
    );
    return readJson<Company>(response, "Company");
  }

  async updateSite(brandId: string, site: Site): Promise<Site> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/sites/${encodeURIComponent(site.id)}`),
      this.json("PUT", site),
    );
    return readJson<Site>(response, "Site");
  }

  async updateDeliveryPoint(
    brandId: string,
    point: DeliveryPoint,
  ): Promise<DeliveryPoint> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/delivery-points/${encodeURIComponent(point.id)}`,
      ),
      this.json("PUT", point),
    );
    return readJson<DeliveryPoint>(response, "DeliveryPoint");
  }

  async getDeliveryPointTechnical(
    brandId: string,
    pointId: string,
    options: { signal?: AbortSignal } = {},
  ): Promise<DeliveryPointTechnical> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/delivery-points/${encodeURIComponent(pointId)}/technical`,
      ),
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<DeliveryPointTechnical>(response, "DeliveryPointTechnical");
  }

  async getDeliveryPointGasControl(
    brandId: string,
    pointId: string,
    options: { from?: string; to?: string; signal?: AbortSignal } = {},
  ): Promise<GasInformativeControl> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/delivery-points/${encodeURIComponent(pointId)}/gas-control${queryString({ from: options.from, to: options.to })}`,
      ),
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<GasInformativeControl>(response, "GasInformativeControl");
  }

  async upsertSiteArea(brandId: string, area: SiteArea): Promise<SiteArea> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/site-areas/${encodeURIComponent(area.id)}`),
      this.json("PUT", area),
    );
    return readJson<SiteArea>(response, "SiteArea");
  }

  async deleteSiteArea(brandId: string, areaId: string): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/site-areas/${encodeURIComponent(areaId)}`),
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  async upsertTag(brandId: string, tag: TagDefinition): Promise<TagDefinition> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/tags/${encodeURIComponent(tag.id)}`),
      this.json("PUT", tag),
    );
    return readJson<TagDefinition>(response, "TagDefinition");
  }

  async deleteTag(brandId: string, tagId: string): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/tags/${encodeURIComponent(tagId)}`),
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  async listSiteTags(
    brandId: string,
    siteId?: string,
  ): Promise<SiteTagAssignment[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/site-tags${queryString({ siteId })}`),
    );
    return readJson<SiteTagAssignment[]>(response, "SiteTagAssignment", true);
  }

  async assignSiteTag(
    brandId: string,
    siteId: string,
    tagId: string,
  ): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/sites/${encodeURIComponent(siteId)}/tags/${encodeURIComponent(tagId)}`,
      ),
      { method: "PUT" },
    );
    await expectNoContent(response);
  }

  async removeSiteTag(
    brandId: string,
    siteId: string,
    tagId: string,
  ): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/sites/${encodeURIComponent(siteId)}/tags/${encodeURIComponent(tagId)}`,
      ),
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  async upsertMeter(brandId: string, meter: Meter): Promise<Meter> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/meters/${encodeURIComponent(meter.id)}`),
      this.json("PUT", meter),
    );
    return readJson<Meter>(response, "Meter");
  }

  async deleteMeter(brandId: string, meterId: string): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/meters/${encodeURIComponent(meterId)}`),
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  async upsertEquipment(
    brandId: string,
    equipment: Equipment,
  ): Promise<Equipment> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/equipment/${encodeURIComponent(equipment.id)}`),
      this.json("PUT", equipment),
    );
    return readJson<Equipment>(response, "Equipment");
  }

  async deleteEquipment(brandId: string, equipmentId: string): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/equipment/${encodeURIComponent(equipmentId)}`),
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  // --- Comptes et accès ---------------------------------------------------

  async updateUser(
    brandId: string,
    userId: string,
    input: UserUpdateInput,
  ): Promise<User> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/users/${encodeURIComponent(userId)}`),
      this.json("PUT", input),
    );
    return readJson<User>(response, "User");
  }

  async deleteUser(
    brandId: string,
    userId: string,
    input: DeleteUserInput,
  ): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/users/${encodeURIComponent(userId)}`),
      this.json("DELETE", input),
    );
    await expectNoContent(response);
  }

  async inviteAccessUser(
    brandId: string,
    user: User,
    initialGrant: AccessGrant,
    reason?: string,
  ): Promise<User> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/access-invitations"),
      this.json("POST", { user, initialGrant, ...(reason ? { reason } : {}) }),
    );
    return readJson<User>(response, "User");
  }

  async assignAccessGrant(
    brandId: string,
    input: {
      userId: string;
      membershipId: string;
      grant: AccessGrant;
      reason?: string;
    },
  ): Promise<Membership> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/access-grants"),
      this.json("POST", input),
    );
    return readJson<Membership>(response, "Membership");
  }

  async previewAccessGrantRevocation(
    brandId: string,
    grantId: string,
    userId: string,
    membershipId: string,
  ): Promise<AccessRevocationImpact> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/access-grants/${encodeURIComponent(grantId)}/revocation-impact${queryString({ userId, membershipId })}`,
      ),
    );
    return readJson<AccessRevocationImpact>(response, "AccessRevocationImpact");
  }

  async revokeAccessGrant(
    brandId: string,
    input: {
      userId: string;
      membershipId: string;
      grantId: string;
      reason?: string;
    },
  ): Promise<Membership> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/access-grants/${encodeURIComponent(input.grantId)}`,
      ),
      this.json("DELETE", input),
    );
    return readJson<Membership>(response, "Membership");
  }

  // --- Connecteurs de la plateforme (super-admin) --------------------------

  async getConnectorDigestSettings(): Promise<ConnectorDigestSettings> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/digest-settings`,
    );
    return readJson<ConnectorDigestSettings>(
      response,
      "ConnectorDigestSettings",
    );
  }

  async updateConnectorDigestSettings(
    input: ConnectorDigestSettingsInput,
  ): Promise<ConnectorDigestSettings> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/digest-settings`,
      this.json("PUT", input),
    );
    return readJson<ConnectorDigestSettings>(
      response,
      "ConnectorDigestSettings",
    );
  }

  async listConnectors(): Promise<Connector[]> {
    const response = await this.fetcher(`${this.baseUrl}/platform/connectors`);
    return readJson<Connector[]>(response, "Connector", true);
  }

  async upsertConnector(connector: Connector): Promise<Connector> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connector.id)}`,
      this.json("PUT", connector),
    );
    return readJson<Connector>(response, "Connector");
  }

  async runConnectorSync(
    connectorId: string,
    input: SyncRunInput = {},
  ): Promise<SyncRun> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/sync-runs`,
      this.json("POST", input),
    );
    return readJson<SyncRun>(response, "SyncRun");
  }

  async listConnectorTransit(
    connectorId: string,
  ): Promise<ConnectorTransitEntry[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/transit`,
    );
    return readJson<ConnectorTransitEntry[]>(
      response,
      "ConnectorTransitEntry",
      true,
    );
  }

  async getConnectorCompleteness(
    connectorId: string,
    reference: string,
  ): Promise<ConnectorCompleteness> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/references/${encodeURIComponent(reference)}/completeness`,
    );
    return readJson<ConnectorCompleteness>(response, "ConnectorCompleteness");
  }

  async getConnectorCoverage(connectorId: string): Promise<ConnectorCoverage> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/coverage`,
    );
    return readJson<ConnectorCoverage>(response, "ConnectorCoverage");
  }

  async listConnectorReferences(
    connectorId: string,
    options: { signal?: AbortSignal } = {},
  ): Promise<ConnectorReferenceEntry[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/references`,
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<ConnectorReferenceEntry[]>(
      response,
      "ConnectorReferenceEntry",
      true,
    );
  }

  async listConnectorEnedisOrders(
    connectorId: string,
    filters: { limit?: number; from?: string; to?: string } = {},
  ): Promise<ConnectorEnedisOrderEntry[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/enedis-orders${queryString(filters)}`,
    );
    return readJson<ConnectorEnedisOrderEntry[]>(
      response,
      "ConnectorEnedisOrderEntry",
      true,
    );
  }

  async listConnectorEnedisFailedFiles(
    connectorId: string,
  ): Promise<ConnectorEnedisFailedFile[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/enedis-failed-files`,
    );
    return readJson<ConnectorEnedisFailedFile[]>(
      response,
      "ConnectorEnedisFailedFile",
      true,
    );
  }

  async setConnectorEnedisFileDiscard(
    connectorId: string,
    input: ConnectorEnedisFileDiscardInput,
  ): Promise<ConnectorEnedisFailedFile[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/enedis-failed-files/discard`,
      this.json("POST", input),
    );
    return readJson<ConnectorEnedisFailedFile[]>(
      response,
      "ConnectorEnedisFailedFile",
      true,
    );
  }

  async listConnectorExclusions(
    connectorId: string,
  ): Promise<ConnectorExclusion[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/exclusions`,
    );
    return readJson<ConnectorExclusion[]>(response, "ConnectorExclusion", true);
  }

  async listConnectorAccessRights(
    connectorId: string,
    options: { refresh?: boolean } = {},
  ): Promise<ConnectorAccessRights> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/access-rights${queryString({ refresh: options.refresh ? "1" : undefined })}`,
    );
    return readJson<ConnectorAccessRights>(response, "ConnectorAccessRights");
  }

  async getConnectorAtrd(connectorId: string): Promise<AtrdStatus> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/atrd`,
    );
    return readJson<AtrdStatus>(response, "AtrdStatus");
  }

  async updateConnectorAtrdSettings(
    connectorId: string,
    input: AtrdSettings,
  ): Promise<AtrdStatus> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/atrd/settings`,
      this.json("PUT", input),
    );
    return readJson<AtrdStatus>(response, "AtrdStatus");
  }

  async syncConnectorAtrd(connectorId: string): Promise<AtrdStatus> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/atrd/sync`,
      { method: "POST" },
    );
    return readJson<AtrdStatus>(response, "AtrdStatus");
  }

  async downloadConnectorAtrd(
    connectorId: string,
    documentId: string,
  ): Promise<Blob> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/atrd/documents/${encodeURIComponent(documentId)}`,
    );
    if (!response.ok) await readJson<unknown>(response);
    return response.blob();
  }

  async listConnectorAccessRightHistory(
    connectorId: string,
    options: { reference?: string } = {},
  ): Promise<ConnectorAccessRightRecord[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/access-rights/history${queryString({ reference: options.reference })}`,
    );
    return readJson<ConnectorAccessRightRecord[]>(
      response,
      "ConnectorAccessRightRecord",
      true,
    );
  }

  async setConnectorExclusion(
    connectorId: string,
    reference: string,
    input: ConnectorExclusionInput,
  ): Promise<ConnectorExclusion[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/exclusions/${encodeURIComponent(reference)}`,
      this.json("PUT", input),
    );
    return readJson<ConnectorExclusion[]>(response, "ConnectorExclusion", true);
  }

  async liftConnectorExclusion(
    connectorId: string,
    reference: string,
  ): Promise<ConnectorExclusion[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/exclusions/${encodeURIComponent(reference)}`,
      { method: "DELETE" },
    );
    return readJson<ConnectorExclusion[]>(response, "ConnectorExclusion", true);
  }

  async getConnectorWeatherClimatology(
    connectorId: string,
    filters: { reference?: string; from?: string; to?: string } = {},
  ): Promise<OfficialWeatherArchive> {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(filters))
      if (value) params.set(key, value);
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/weather-climatology?${params}`,
    );
    return readJson<OfficialWeatherArchive>(response, "OfficialWeatherArchive");
  }

  async addConnectorWeatherIdentifier(
    connectorId: string,
    input: WeatherStationIdentifierInput,
  ): Promise<OfficialWeatherArchive> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/weather-identifiers`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      },
    );
    return readJson<OfficialWeatherArchive>(response, "OfficialWeatherArchive");
  }

  async listConnectorWeatherImports(
    connectorId: string,
  ): Promise<WeatherImportEntry[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/weather-imports`,
    );
    return readJson<WeatherImportEntry[]>(response, "WeatherImportEntry", true);
  }

  async listMeteringPointSeries(
    reference: string,
    options: { signal?: AbortSignal } = {},
  ): Promise<MeteringPointSeries[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/metering-points/${encodeURIComponent(reference)}/series`,
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<MeteringPointSeries[]>(
      response,
      "MeteringPointSeries",
      true,
    );
  }

  async listMeteringPointMeasurements(
    reference: string,
    filters: {
      seriesId: string;
      from?: string;
      to?: string;
      order?: "asc" | "desc";
      bucket?: "raw" | "hour" | "day";
      limit?: number;
      offset?: number;
    },
    options: { signal?: AbortSignal } = {},
  ): Promise<MeteringPointMeasurements> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/metering-points/${encodeURIComponent(reference)}/measurements${queryString(filters)}`,
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<MeteringPointMeasurements>(
      response,
      "MeteringPointMeasurements",
    );
  }

  async listGtbInstallations(
    options: { signal?: AbortSignal } = {},
  ): Promise<GtbOverview> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-installations`,
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<GtbOverview>(response, "GtbOverview");
  }

  async previewGtbAssociationBatch(
    installationId: string,
  ): Promise<GtbAssociationBatchPreview> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-installations/${encodeURIComponent(installationId)}/associations/batch-preview`,
      this.json("POST"),
    );
    return readJson<GtbAssociationBatchPreview>(
      response,
      "GtbAssociationBatchPreview",
    );
  }

  async applyGtbAssociationBatch(
    installationId: string,
    input: GtbAssociationBatchApplyInput,
  ): Promise<GtbAssociationBatchResult> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-installations/${encodeURIComponent(installationId)}/associations/batch-apply`,
      this.json("POST", input),
    );
    return readJson<GtbAssociationBatchResult>(
      response,
      "GtbAssociationBatchResult",
    );
  }

  async previewGtbAssociation(
    installationId: string,
    input: GtbAssociationInput,
  ): Promise<GtbAssociationPreview> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-installations/${encodeURIComponent(installationId)}/associations/preview`,
      this.json("POST", input),
    );
    return readJson<GtbAssociationPreview>(response, "GtbAssociationPreview");
  }

  async applyGtbAssociation(
    installationId: string,
    input: GtbAssociationApplyInput,
  ): Promise<GtbAssociationPreview> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-installations/${encodeURIComponent(installationId)}/associations/apply`,
      this.json("POST", input),
    );
    return readJson<GtbAssociationPreview>(response, "GtbAssociationPreview");
  }

  async listGtbSensorValues(
    sensorId: string,
    filters: {
      from: string;
      to: string;
      bucket?: "raw" | "hour" | "day";
      aggregation?: "mean" | "min" | "max" | "last";
      order?: "asc" | "desc";
      limit?: number;
      offset?: number;
    },
    options: { signal?: AbortSignal } = {},
  ): Promise<GtbSensorValues> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-sensors/${encodeURIComponent(sensorId)}/values${queryString(filters)}`,
      options.signal ? { signal: options.signal } : undefined,
    );
    return readJson<GtbSensorValues>(response, "GtbSensorValues");
  }

  async attachGtbInstallation(
    installationId: string,
    input: GtbAttachmentInput,
  ): Promise<GtbInstallation> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-installations/${encodeURIComponent(installationId)}/attachment`,
      this.json("PUT", input),
    );
    return readJson<GtbInstallation>(response, "GtbInstallation");
  }

  async detachGtbInstallation(
    installationId: string,
  ): Promise<GtbInstallation> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/gtb-installations/${encodeURIComponent(installationId)}/attachment`,
      { method: "DELETE" },
    );
    return readJson<GtbInstallation>(response, "GtbInstallation");
  }

  async getConnectorModuleSync(connectorId: string): Promise<ModuleSyncStatus> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/module-sync`,
    );
    return readJson<ModuleSyncStatus>(response, "ModuleSyncStatus");
  }

  async updateConnectorModuleSettings(
    connectorId: string,
    input: ModuleSettingsInput,
  ): Promise<ModuleSyncStatus> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/module-settings`,
      this.json("PUT", input),
    );
    return readJson<ModuleSyncStatus>(response, "ModuleSyncStatus");
  }

  async listConnectorModuleRuns(
    connectorId: string,
    filters: { limit?: number; from?: string; to?: string } = {},
  ): Promise<ModuleRunEntry[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/module-runs${queryString(filters)}`,
    );
    return readJson<ModuleRunEntry[]>(response, "ModuleRunEntry", true);
  }

  async searchConnectorHttpRuns(
    connectorId: string,
    filters: Partial<ConnectorHttpFilter> & {
      from?: string;
      to?: string;
      limit?: number;
    } = {},
  ): Promise<ConnectorHttpRunSearch> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/http-diagnostics/runs${queryString(filters)}`,
    );
    return readJson<ConnectorHttpRunSearch>(response, "ConnectorHttpRunSearch");
  }

  async listConnectorHttpRequests(
    connectorId: string,
    runId: string,
  ): Promise<ConnectorHttpJournal> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/module-runs/${encodeURIComponent(runId)}/requests`,
    );
    return readJson<ConnectorHttpJournal>(response, "ConnectorHttpJournal");
  }
  async getConnectorHttpResponse(
    connectorId: string,
    runId: string,
    requestId: string,
  ): Promise<ConnectorHttpResponse> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/module-runs/${encodeURIComponent(runId)}/requests/${encodeURIComponent(requestId)}`,
    );
    return readJson<ConnectorHttpResponse>(response, "ConnectorHttpResponse");
  }

  async purgeConnectorHttpDiagnostics(
    connectorId: string,
    input: ConnectorHttpPurgeInput,
  ): Promise<ConnectorHttpPurgeReport> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/http-diagnostics/purge`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      },
    );
    return readJson<ConnectorHttpPurgeReport>(
      response,
      "ConnectorHttpPurgeReport",
    );
  }

  async getConnectorModuleRunLog(
    connectorId: string,
    runId: string,
  ): Promise<ModuleRunLog> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/module-runs/${encodeURIComponent(runId)}/log`,
    );
    return readJson<ModuleRunLog>(response, "ModuleRunLog");
  }

  async listPlatformAuditEvents(
    filters: { limit?: number; before?: string } = {},
  ): Promise<AuditEvent[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/audit-events${queryString(filters)}`,
    );
    return readJson<AuditEvent[]>(response, "AuditEvent", true);
  }

  async listPlatformAccountActivity(
    filters: {
      limit?: number;
      cursor?: string;
      from?: string;
      to?: string;
      brandId?: string;
      scope?: "platform";
      actorRole?: "super_admin" | "manager" | "client" | "system" | "unknown";
      search?: string;
    } = {},
  ): Promise<AccountActivityPage> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/account-activity${queryString(filters)}`,
    );
    return readJson<AccountActivityPage>(response, "AccountActivityPage");
  }

  async listPlatformEmailLogs(
    filters: {
      limit?: number;
      cursor?: string;
      from?: string;
      to?: string;
      brandId?: string;
      status?: EmailLogStatus;
      channel?: "platform" | "mandate";
      emailType?: string;
      search?: string;
    } = {},
  ): Promise<EmailLogListResponse> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/email-logs${queryString(filters)}`,
    );
    return readJson<EmailLogListResponse>(response, "EmailLogListResponse");
  }

  async getPlatformEmailLog(emailLogId: string): Promise<EmailLogDetail> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/email-logs/${encodeURIComponent(emailLogId)}`,
    );
    return readJson<EmailLogDetail>(response, "EmailLogDetail");
  }

  async listSyncRuns(connectorId?: string): Promise<SyncRun[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/sync-runs${queryString({ connectorId })}`,
    );
    return readJson<SyncRun[]>(response, "SyncRun", true);
  }

  async listPointSyncs(brandId: string): Promise<PointSyncStatus[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/point-syncs"),
    );
    return readJson<PointSyncStatus[]>(response, "PointSyncStatus", true);
  }

  // --- Mesures -------------------------------------------------------------

  async listMeasurements(
    brandId: string,
    filters: {
      seriesIds?: string[];
      from?: string;
      to?: string;
      revisions?: "current" | "all";
    } = {},
  ): Promise<MeasurementBatch[]> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/measurements${queryString({ seriesId: filters.seriesIds?.join(","), from: filters.from, to: filters.to, revisions: filters.revisions })}`,
      ),
    );
    return readJson<MeasurementBatch[]>(response, "MeasurementBatch", true);
  }

  async correctMeasurement(
    brandId: string,
    seriesId: string,
    valueId: string,
    input: MeasurementCorrectionInput,
  ): Promise<MeasurementCorrectionResult> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/series/${encodeURIComponent(seriesId)}/measurements/${encodeURIComponent(valueId)}/corrections`,
      ),
      this.json("POST", input),
    );
    return readJson<MeasurementCorrectionResult>(
      response,
      "MeasurementCorrectionResult",
    );
  }

  // --- Analyses et workflows ---------------------------------------------

  async getSiteOfficialDegreeDays(
    brandId: string,
    siteId: string,
    from: string,
    to: string,
  ): Promise<SiteOfficialDegreeDays> {
    const params = new URLSearchParams({ from, to });
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/sites/${encodeURIComponent(siteId)}/degree-days?${params}`,
      ),
    );
    return readJson<SiteOfficialDegreeDays>(response, "SiteOfficialDegreeDays");
  }

  async getSiteWeatherStations(
    brandId: string,
    siteId: string,
  ): Promise<WeatherStationCatalog> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/sites/${encodeURIComponent(siteId)}/weather-stations`,
      ),
    );
    return readJson<WeatherStationCatalog>(response, "WeatherStationCatalog");
  }

  async getSiteWeatherObservations(
    brandId: string,
    siteId: string,
    input: { station: string; parameter: string; from: string; to: string },
  ): Promise<WeatherObservations> {
    const params = new URLSearchParams(input);
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/sites/${encodeURIComponent(siteId)}/weather-observations?${params}`,
      ),
    );
    return readJson<WeatherObservations>(response, "WeatherObservations");
  }

  async getConnectorWeatherStations(
    connectorId: string,
  ): Promise<WeatherStationCatalog> {
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/weather-stations`,
    );
    return readJson<WeatherStationCatalog>(response, "WeatherStationCatalog");
  }

  async getConnectorWeatherObservations(
    connectorId: string,
    input: { station: string; parameter: string; from: string; to: string },
  ): Promise<WeatherObservations> {
    const params = new URLSearchParams(input);
    const response = await this.fetcher(
      `${this.baseUrl}/platform/connectors/${encodeURIComponent(connectorId)}/weather-observations?${params}`,
    );
    return readJson<WeatherObservations>(response, "WeatherObservations");
  }

  async getSiteWeather(
    brandId: string,
    siteId: string,
  ): Promise<SiteWeatherCoverage[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/sites/${encodeURIComponent(siteId)}/weather`),
    );
    return readJson<SiteWeatherCoverage[]>(
      response,
      "SiteWeatherCoverage",
      true,
    );
  }

  async explorerSources(
    brandId: string,
    input: ExplorerInput,
    options: { signal?: AbortSignal } = {},
  ): Promise<ExplorerSource[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/data-explorer/sources"),
      { ...this.json("POST", input), signal: options.signal ?? null },
    );
    return readJson<ExplorerSource[]>(response, "ExplorerSource", true);
  }

  async calculateScopeAnalysis(
    brandId: string,
    input: ScopeAnalysisInput,
  ): Promise<ScopeAnalysisResult> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/scope-analyses"),
      this.json("POST", input),
    );
    return readJson<ScopeAnalysisResult>(response, "ScopeAnalysisResult");
  }

  async queryExplorer(
    brandId: string,
    input: ExplorerInput,
    options: { signal?: AbortSignal } = {},
  ): Promise<ExplorerResult> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/data-explorer/query"),
      { ...this.json("POST", input), signal: options.signal ?? null },
    );
    return readJson<ExplorerResult>(response, "ExplorerResult");
  }

  async getSiteDashboard(
    brandId: string,
    siteId: string,
  ): Promise<SiteDashboard> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/sites/${encodeURIComponent(siteId)}/dashboard`),
    );
    return readJson<SiteDashboard>(response, "SiteDashboard");
  }

  async getAnalysisAvailability(
    brandId: string,
    siteId: string,
  ): Promise<AnalysisAvailability[]> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/sites/${encodeURIComponent(siteId)}/analysis-availability`,
      ),
    );
    return readJson<AnalysisAvailability[]>(
      response,
      "AnalysisAvailability",
      true,
    );
  }

  async calculateAnalysis(
    brandId: string,
    request: AnalysisRequest,
  ): Promise<AnalysisResponse> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/analyses/${encodeURIComponent(request.code)}`),
      this.json("POST", request),
    );
    return readJson<AnalysisResponse>(response, "AnalysisResponse");
  }

  async upsertWorkflowItem(
    brandId: string,
    kind: "anomalies" | "recommendations" | "works" | "reports",
    item: WorkflowItem,
    publicationToken?: string,
  ): Promise<WorkflowItem> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/workflow-items"),
      this.json("POST", {
        kind,
        item,
        ...(publicationToken ? { publicationToken } : {}),
      }),
    );
    return readJson<WorkflowItem>(response, "WorkflowItem");
  }

  async listSavedViews(
    brandId: string,
    screen?: SavedViewScreen,
  ): Promise<SavedView[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/saved-views${queryString({ screen })}`),
    );
    return readJson<SavedView[]>(response, "SavedView", true);
  }

  async exportPortfolio(
    brandId: string,
    input: PortfolioExportInput,
  ): Promise<PortfolioExport> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/portfolio/export"),
      this.json("POST", input),
    );
    return readJson<PortfolioExport>(response, "PortfolioExport");
  }

  async saveViewPreference(
    brandId: string,
    viewId: string,
    input: SavedViewPreferenceInput,
  ): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/saved-views/${encodeURIComponent(viewId)}/preference`,
      ),
      this.json("PUT", input),
    );
    await expectNoContent(response);
  }

  async saveView(
    brandId: string,
    viewId: string,
    input: SaveViewInput,
  ): Promise<SavedView> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/saved-views/${encodeURIComponent(viewId)}`),
      this.json("PUT", input),
    );
    return readJson<SavedView>(response, "SavedView");
  }

  async deleteSavedView(
    brandId: string,
    viewId: string,
    expectedVersion: number,
  ): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/saved-views/${encodeURIComponent(viewId)}${queryString({ expectedVersion })}`,
      ),
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  async listWorkflowComments(
    brandId: string,
    itemId: string,
  ): Promise<WorkflowComment[]> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/comments`,
      ),
    );
    return readJson<WorkflowComment[]>(response, "WorkflowComment", true);
  }

  async listDashboards(brandId: string): Promise<DashboardComposition[]> {
    return readJson<DashboardComposition[]>(
      await this.fetcher(this.brandPath(brandId, "/dashboards")),
      "DashboardComposition",
      true,
    );
  }
  async saveDashboard(
    brandId: string,
    input: DashboardComposition,
  ): Promise<DashboardComposition> {
    return readJson<DashboardComposition>(
      await this.fetcher(
        this.brandPath(brandId, "/dashboards"),
        this.json("PUT", input),
      ),
      "DashboardComposition",
    );
  }
  async actDashboard(
    brandId: string,
    id: string,
    action: "publish" | "withdraw" | "visited",
    expectedRevision: number,
  ): Promise<DashboardComposition> {
    return readJson<DashboardComposition>(
      await this.fetcher(
        this.brandPath(
          brandId,
          `/dashboards/${encodeURIComponent(id)}/${action}`,
        ),
        this.json("POST", { expectedRevision }),
      ),
      "DashboardComposition",
    );
  }
  async prepareDashboardResult(
    brandId: string,
    input: EnergyReportInput,
  ): Promise<DashboardResult> {
    return readJson<DashboardResult>(
      await this.fetcher(
        this.brandPath(brandId, "/dashboard-results"),
        this.json("POST", input),
      ),
      "DashboardResult",
    );
  }
  async getDashboardResult(
    brandId: string,
    id: string,
  ): Promise<DashboardResult> {
    return readJson<DashboardResult>(
      await this.fetcher(
        this.brandPath(brandId, `/dashboard-results/${encodeURIComponent(id)}`),
      ),
      "DashboardResult",
    );
  }
  async getEnergyReportPolicy(brandId: string): Promise<EnergyReportPolicy> {
    return readJson<EnergyReportPolicy>(
      await this.fetcher(this.brandPath(brandId, "/energy-reports/policy")),
      "EnergyReportPolicy",
    );
  }
  async previewEnergyReport(
    brandId: string,
    input: EnergyReportInput,
  ): Promise<EnergyReportPreview> {
    return readJson<EnergyReportPreview>(
      await this.fetcher(
        this.brandPath(brandId, "/energy-reports/preview"),
        this.json("POST", input),
      ),
      "EnergyReportPreview",
    );
  }
  async createEnergyReport(
    brandId: string,
    input: {
      snapshot: EnergyReportSnapshot;
      token: string;
      idempotencyKey: string;
    },
  ): Promise<EnergyReport> {
    return readJson<EnergyReport>(
      await this.fetcher(
        this.brandPath(brandId, "/energy-reports"),
        this.json("POST", input),
      ),
      "EnergyReport",
    );
  }
  async listEnergyReports(brandId: string): Promise<EnergyReport[]> {
    return readJson<EnergyReport[]>(
      await this.fetcher(this.brandPath(brandId, "/energy-reports")),
      "EnergyReport",
      true,
    );
  }
  async actEnergyReport(
    brandId: string,
    id: string,
    action: "approve" | "withdraw" | "dispatch",
    expectedRevision: number,
  ): Promise<EnergyReport> {
    return readJson<EnergyReport>(
      await this.fetcher(
        this.brandPath(
          brandId,
          `/energy-reports/${encodeURIComponent(id)}/${action}`,
        ),
        this.json("POST", { expectedRevision }),
      ),
      "EnergyReport",
    );
  }
  async downloadEnergyReport(
    brandId: string,
    id: string,
    format: "pdf" | "csv",
  ): Promise<Blob> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/energy-reports/${encodeURIComponent(id)}/${format}`,
      ),
    );
    if (!response.ok) await readJson<unknown>(response);
    return response.blob();
  }
  async listReportSchedules(brandId: string): Promise<EnergyReportSchedule[]> {
    return readJson<EnergyReportSchedule[]>(
      await this.fetcher(this.brandPath(brandId, "/report-schedules")),
      "EnergyReportSchedule",
      true,
    );
  }
  async saveReportSchedule(
    brandId: string,
    input: EnergyReportSchedule,
  ): Promise<EnergyReportSchedule> {
    return readJson<EnergyReportSchedule>(
      await this.fetcher(
        this.brandPath(brandId, "/report-schedules"),
        this.json("PUT", input),
      ),
      "EnergyReportSchedule",
    );
  }
  async parseReferenceImport(
    brandId: string,
    input: ReferenceImportFile,
  ): Promise<ReferenceImportTable> {
    return readJson<ReferenceImportTable>(
      await this.fetcher(
        this.brandPath(brandId, "/reference-batches/parse"),
        this.json("POST", input),
      ),
      "ReferenceImportTable",
    );
  }
  async previewReferenceBatch(
    brandId: string,
    input: ReferenceBatchInput,
  ): Promise<ReferenceBatchPreview> {
    return readJson<ReferenceBatchPreview>(
      await this.fetcher(
        this.brandPath(brandId, "/reference-batches/preview"),
        this.json("POST", input),
      ),
      "ReferenceBatchPreview",
    );
  }
  async createReferenceBatch(
    brandId: string,
    input: {
      input: ReferenceBatchInput;
      previewToken: string;
      idempotencyKey: string;
    },
  ): Promise<ReferenceBatchJob> {
    return readJson<ReferenceBatchJob>(
      await this.fetcher(
        this.brandPath(brandId, "/reference-batches"),
        this.json("POST", input),
      ),
      "ReferenceBatchJob",
    );
  }
  async listReferenceBatches(brandId: string): Promise<ReferenceBatchJob[]> {
    return readJson<ReferenceBatchJob[]>(
      await this.fetcher(this.brandPath(brandId, "/reference-batches")),
      "ReferenceBatchJob",
      true,
    );
  }
  async actReferenceBatch(
    brandId: string,
    jobId: string,
    action: "apply" | "cancel" | "compensate",
    input: ReferenceBatchAction,
  ): Promise<ReferenceBatchJob> {
    return readJson<ReferenceBatchJob>(
      await this.fetcher(
        this.brandPath(
          brandId,
          `/reference-batches/${encodeURIComponent(jobId)}/${action}`,
        ),
        this.json("POST", input),
      ),
      "ReferenceBatchJob",
    );
  }
  async previewWorkflowPublication(
    brandId: string,
    itemId: string,
  ): Promise<WorkflowPublicationPreview> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/publication-preview`,
      ),
    );
    return readJson<WorkflowPublicationPreview>(
      response,
      "WorkflowPublicationPreview",
    );
  }
  async listWorkflowPublications(
    brandId: string,
    itemId: string,
  ): Promise<WorkflowPublication[]> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/publications`,
      ),
    );
    return readJson<WorkflowPublication[]>(
      response,
      "WorkflowPublication",
      true,
    );
  }
  async getAccessInvitation(
    brandId: string,
    userId: string,
  ): Promise<AccessInvitationState> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/users/${encodeURIComponent(userId)}/invitation`,
      ),
    );
    return readJson<AccessInvitationState>(response, "AccessInvitationState");
  }
  async updateAccessInvitation(
    brandId: string,
    userId: string,
    input: AccessInvitationAction,
  ): Promise<AccessInvitationState> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/users/${encodeURIComponent(userId)}/invitation`,
      ),
      this.json("POST", input),
    );
    return readJson<AccessInvitationState>(response, "AccessInvitationState");
  }
  async listWorkflowAttachments(
    brandId: string,
    itemId: string,
  ): Promise<WorkflowAttachments> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/attachments`,
      ),
    );
    return readJson<WorkflowAttachments>(response, "WorkflowAttachments");
  }
  async uploadWorkflowAttachment(
    brandId: string,
    itemId: string,
    input: WorkflowAttachmentInput,
  ): Promise<WorkflowAttachment> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/attachments`,
      ),
      this.json("POST", input),
    );
    return readJson<WorkflowAttachment>(response, "WorkflowAttachment");
  }
  async getWorkflowAttachmentTicket(
    brandId: string,
    itemId: string,
    attachmentId: string,
  ): Promise<AttachmentTicket> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/attachments/${encodeURIComponent(attachmentId)}/ticket`,
      ),
      { method: "POST" },
    );
    return readJson<AttachmentTicket>(response, "AttachmentTicket");
  }
  async downloadWorkflowAttachment(
    brandId: string,
    itemId: string,
    attachmentId: string,
    token: string,
  ): Promise<Blob> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/attachments/${encodeURIComponent(attachmentId)}/download?token=${encodeURIComponent(token)}`,
      ),
    );
    if (!response.ok) await readJson<unknown>(response);
    return response.blob();
  }

  async editWorkflowComment(
    brandId: string,
    itemId: string,
    commentId: string,
    input: WorkflowCommentEdit,
  ): Promise<WorkflowComment> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/comments/${encodeURIComponent(commentId)}`,
      ),
      this.json("PUT", input),
    );
    return readJson<WorkflowComment>(response, "WorkflowComment");
  }

  async listWorkflowAssignees(
    brandId: string,
    siteId: string,
  ): Promise<WorkflowAssignee[]> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/sites/${encodeURIComponent(siteId)}/workflow-assignees`,
      ),
    );
    return readJson<WorkflowAssignee[]>(response, "WorkflowAssignee", true);
  }

  async addWorkflowComment(
    brandId: string,
    itemId: string,
    input: WorkflowCommentInput,
  ): Promise<WorkflowComment> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/workflow-items/${encodeURIComponent(itemId)}/comments`,
      ),
      this.json("POST", input),
    );
    return readJson<WorkflowComment>(response, "WorkflowComment");
  }

  async listNotifications(brandId: string): Promise<Notification[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/notifications"),
    );
    return readJson<Notification[]>(response, "Notification", true);
  }

  async readNotification(
    brandId: string,
    notificationId: string,
    input: NotificationStateInput = { read: true },
  ): Promise<Notification> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/notifications/${encodeURIComponent(notificationId)}/read`,
      ),
      this.json("PUT", input),
    );
    return readJson<Notification>(response, "Notification");
  }

  async listNotificationPreferences(
    brandId: string,
  ): Promise<NotificationPreference[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/notification-preferences"),
    );
    return readJson<NotificationPreference[]>(
      response,
      "NotificationPreference",
      true,
    );
  }

  async saveNotificationPreference(
    brandId: string,
    eventType: string,
    input: NotificationPreferenceInput,
  ): Promise<NotificationPreference> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/notification-preferences/${encodeURIComponent(eventType)}`,
      ),
      this.json("PUT", input),
    );
    return readJson<NotificationPreference>(response, "NotificationPreference");
  }

  // --- Audit, factures, performance --------------------------------------

  async listAuditEvents(
    brandId: string,
    filters: { limit?: number; before?: string } = {},
  ): Promise<AuditEvent[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/audit-events${queryString(filters)}`),
    );
    return readJson<AuditEvent[]>(response, "AuditEvent", true);
  }

  async listInvoices(
    brandId: string,
    filters: { siteId?: string; deliveryPointId?: string } = {},
  ): Promise<SupplierInvoice[]> {
    const response = await this.fetcher(
      this.brandPath(brandId, `/invoices${queryString(filters)}`),
    );
    return readJson<SupplierInvoice[]>(response, "SupplierInvoice", true);
  }

  async createInvoice(
    brandId: string,
    input: SupplierInvoiceInput,
  ): Promise<SupplierInvoice> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/invoices"),
      this.json("POST", input),
    );
    return readJson<SupplierInvoice>(response, "SupplierInvoice");
  }

  async previewInvoiceImport(
    brandId: string,
    input: InvoiceImportInput,
  ): Promise<InvoiceImportPreview> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/invoices/import/preview"),
      this.json("POST", input),
    );
    return readJson<InvoiceImportPreview>(response, "InvoiceImportPreview");
  }
  async confirmInvoiceImport(
    brandId: string,
    input: InvoiceImportInput,
  ): Promise<InvoiceImportResult> {
    const response = await this.fetcher(
      this.brandPath(brandId, "/invoices/import/confirm"),
      this.json("POST", input),
    );
    return readJson<InvoiceImportResult>(response, "InvoiceImportResult");
  }

  async reviewInvoice(
    brandId: string,
    invoiceId: string,
    input: InvoiceReviewInput,
  ): Promise<SupplierInvoice> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/invoices/${encodeURIComponent(invoiceId)}/review`,
      ),
      this.json("PUT", input),
    );
    return readJson<SupplierInvoice>(response, "SupplierInvoice");
  }

  async listPerformancePeriods(
    brandId: string,
    siteId?: string,
  ): Promise<CpePerformancePeriod[]> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/performance-contracts${queryString({ siteId })}`,
      ),
    );
    return readJson<CpePerformancePeriod[]>(
      response,
      "CpePerformancePeriod",
      true,
    );
  }

  async upsertPerformancePeriod(
    brandId: string,
    periodId: string,
    input: CpePerformancePeriodInput,
  ): Promise<CpePerformancePeriod> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/performance-contracts/${encodeURIComponent(periodId)}`,
      ),
      this.json("PUT", input),
    );
    return readJson<CpePerformancePeriod>(response, "CpePerformancePeriod");
  }

  async deletePerformancePeriod(
    brandId: string,
    periodId: string,
  ): Promise<void> {
    const response = await this.fetcher(
      this.brandPath(
        brandId,
        `/performance-contracts/${encodeURIComponent(periodId)}`,
      ),
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  // --- Démonstration ------------------------------------------------------

  async resetDemo(): Promise<void> {
    const response = await this.fetcher(`${this.baseUrl}/demo/reset`, {
      method: "POST",
    });
    await expectNoContent(response);
  }
}

export class MandateApiClient {
  private readonly baseUrl: string;
  private readonly fetcher: typeof fetch;

  constructor(baseUrl = "/api/v1", fetcher: typeof fetch = fetch) {
    this.baseUrl = baseUrl;
    // See EmsApiClient: injected transports and window.fetch must never receive
    // the generated client instance as their JavaScript receiver.
    this.fetcher = (input, init) => fetcher(input, init);
  }

  async getFormDraft(brandId: string): Promise<MandateFormDraft | null> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-form-draft`,
    );
    if (response.status === 204) return null;
    return readJson<MandateFormDraft>(response, "MandateFormDraft");
  }

  async saveFormDraft(
    brandId: string,
    input: SaveMandateFormDraftInput,
  ): Promise<MandateFormDraft> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-form-draft`,
      {
        method: "PUT",
        headers: JSON_HEADERS,
        body: JSON.stringify(input),
      },
    );
    return readJson<MandateFormDraft>(response, "MandateFormDraft");
  }

  async deleteFormDraft(brandId: string): Promise<void> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-form-draft`,
      { method: "DELETE" },
    );
    await expectNoContent(response);
  }

  async listCases(brandId: string): Promise<MandateCase[]> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-cases`,
    );
    return readJson<MandateCase[]>(response, "MandateCase", true);
  }

  async createCase(
    brandId: string,
    input: MandateDraftInput,
  ): Promise<MandateCase> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-cases`,
      {
        method: "POST",
        headers: JSON_HEADERS,
        body: JSON.stringify(input),
      },
    );
    return readJson<MandateCase>(response, "MandateCase");
  }

  async createPublicLink(
    brandId: string,
    input: {
      companyId?: string;
      siteId?: string;
      email?: string;
      phone?: string;
    },
  ): Promise<MandatePublicLinkResult> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-public-links`,
      {
        method: "POST",
        headers: JSON_HEADERS,
        body: JSON.stringify(input),
      },
    );
    return readJson<MandatePublicLinkResult>(
      response,
      "MandatePublicLinkResult",
    );
  }

  async providerStatus(check = false): Promise<YoutrustProviderStatus> {
    const response = await this.fetcher(
      `${this.baseUrl}/mandates/provider-status`,
      { method: check ? "POST" : "GET" },
    );
    return readJson<YoutrustProviderStatus>(response, "YoutrustProviderStatus");
  }

  documentUrl(brandId: string, mandateId: string): string {
    return `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-cases/${encodeURIComponent(mandateId)}/document`;
  }

  async document(brandId: string, mandateId: string): Promise<Blob> {
    const response = await this.fetcher(this.documentUrl(brandId, mandateId));
    if (!response.ok) {
      await readJson<unknown>(response);
    }
    return response.blob();
  }

  async send(brandId: string, mandateId: string): Promise<MandateCase> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-cases/${encodeURIComponent(mandateId)}/send`,
      { method: "POST" },
    );
    return readJson<MandateCase>(response, "MandateCase");
  }

  async revoke(brandId: string, mandateId: string): Promise<MandateCase> {
    const response = await this.fetcher(
      `${this.baseUrl}/brands/${encodeURIComponent(brandId)}/mandate-cases/${encodeURIComponent(mandateId)}/revoke`,
      { method: "POST" },
    );
    return readJson<MandateCase>(response, "MandateCase");
  }

  async getPublicForm(token: string): Promise<PublicMandateForm> {
    const response = await this.fetcher(
      `${this.baseUrl}/public/mandate-links/${encodeURIComponent(token)}`,
    );
    return readJson<PublicMandateForm>(response, "PublicMandateForm");
  }

  async submitPublicForm(
    token: string,
    input: MandateDraftInput,
  ): Promise<PublicMandateSubmission> {
    const response = await this.fetcher(
      `${this.baseUrl}/public/mandate-links/${encodeURIComponent(token)}`,
      {
        method: "POST",
        headers: JSON_HEADERS,
        body: JSON.stringify(input),
      },
    );
    return readJson<PublicMandateSubmission>(
      response,
      "PublicMandateSubmission",
    );
  }
}
